const ExplainExpressionTestIdsScope = {
  EXPLAIN_EXPRESSION: 'explain-expression',
};

export const ExplainExpressionTestIds = {
  BUTTON: `${ExplainExpressionTestIdsScope.EXPLAIN_EXPRESSION}.button`,
  MODAL_BODY: `${ExplainExpressionTestIdsScope.EXPLAIN_EXPRESSION}.modal-body`,
  MODAL_LOADING: `${ExplainExpressionTestIdsScope.EXPLAIN_EXPRESSION}.modal-loading`,
  MODAL_ERROR: `${ExplainExpressionTestIdsScope.EXPLAIN_EXPRESSION}.modal-error`,
  MODAL_SUMMARY: `${ExplainExpressionTestIdsScope.EXPLAIN_EXPRESSION}.modal-summary`,
  MODAL_READS: `${ExplainExpressionTestIdsScope.EXPLAIN_EXPRESSION}.modal-reads`,
  MODAL_WATCH_OUT: `${ExplainExpressionTestIdsScope.EXPLAIN_EXPRESSION}.modal-watch-out`,
};
